# v-a11y-click
# Makes a non-native interactive element (div, v-card, v-flex, etc. that only
# has an @click handler) operable by keyboard, satisfying WCAG 2.1:
#   - 2.1.1 Keyboard          (Enter / Space activate it)
#   - 2.4.7 Focus Visible     (becomes focusable, picks up the global focus ring)
#   - 4.1.2 Name, Role, Value (gets role="button" if none was set)
#
# Usage (place on the SAME element that owns the @click handler):
#   div(v-a11y-click role="button" aria-label="Select item" @click="add(item)")
#
# On Enter/Space it dispatches a native click, so the existing @click handler
# runs unchanged. Keys are ignored when focus is on a nested form control / link
# so typing in inputs is never hijacked.

export default
  bind: (el) ->
    el.setAttribute('tabindex', '0') unless el.hasAttribute('tabindex')
    el.setAttribute('role', 'button') unless el.hasAttribute('role')

    handler = (event) ->
      return unless event.key == 'Enter' or event.key == ' ' or event.key == 'Spacebar'
      target = event.target
      # Let nested inputs / links / buttons handle their own keys.
      if target != el and target.closest and target.closest('input, textarea, select, a, button, [contenteditable="true"]')
        return
      event.preventDefault()
      el.click()

    el.__a11yClickHandler__ = handler
    el.addEventListener 'keydown', handler

  unbind: (el) ->
    el.removeEventListener('keydown', el.__a11yClickHandler__) if el.__a11yClickHandler__
    delete el.__a11yClickHandler__
